/* Attention snoozes: × hides an item for 24 hours, for this person only, on every
   device. Saved whole after each change; a failed save keeps it for this visit. */

import { useCallback, useEffect, useRef, useState } from 'react';
import { api } from '../api/client';
import { snooze, unsnooze } from './attention';

export function useSnoozes() {
  const [snoozes, setSnoozes] = useState<Record<string, string>>({});
  const latest = useRef(snoozes);
  latest.current = snoozes;

  useEffect(() => {
    let live = true;
    api.getDashboardDismissed()
      .then((d) => { if (live && d && typeof d === 'object') setSnoozes(d); })
      .catch(() => {});
    return () => { live = false; };
  }, []);

  // A snooze ending while the page is open brings its item back.
  const [, setTick] = useState(0);
  useEffect(() => {
    const now = Date.now();
    const next = Object.values(snoozes).map((u) => Date.parse(u)).filter((u) => u > now).sort((a, b) => a - b)[0];
    if (!next) return;
    const id = window.setTimeout(() => setTick((n) => n + 1), Math.min(next - now + 500, 2 ** 31 - 1));
    return () => window.clearTimeout(id);
  }, [snoozes]);

  const setSnoozed = useCallback((keys: string[], on: boolean) => {
    const next = on ? snooze(latest.current, keys, Date.now()) : unsnooze(latest.current, keys);
    setSnoozes(next);
    api.saveDashboardDismissed(next).catch(() => {});
  }, []);

  return { snoozes, setSnoozed };
}
